import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Utils } from "arv-reactcomponents";

import {
  Button,
  Input,
  GridContainer,
  GridColumn,
  GridRow,
} from "arv-reactcomponents";
import { Checkout } from "npmlinks-constants";

@inject("AddressStore")
@observer
class PincodeChangeBlock extends Component {
  constructor() {
    super();
    this.state = {
      isPincodeValid: false,
      pincode: "",
      pincodeErrorMsg: "",
      // showPincodeForm: false,
    };
    this.pincodeInput = null;
    this.init = this.init.bind(this);
    this.pinCodeSubmit = this.pinCodeSubmit.bind(this);
    this.validatePincode = this.validatePincode.bind(this);
  }
  componentDidMount() {
    this.init();
  }

  init() {
    const { currentPincode } = this.props;
    const bool = !!currentPincode;
    this.setState({ pincode: currentPincode, isPincodeValid: bool });
    Utils.fixScroll();
  }
  get isPincodeValid() {
    return !this.state.isPincodeValid;
  }

  pinCodeSubmit(e, initPincode) {
    if (e) {
      e.preventDefault();
    }
    Utils.unFixScroll();
    const pincode = initPincode || this.state.pincode;
    this.props.onPincodeChange(pincode);
  }
  validatePincode(e) {
    const validatePincodeField = this.pincodeInput.getValidatedOutput(
      e.target.value,
    );
    if (validatePincodeField.value.length < 6)
      validatePincodeField.isValid = false;
    this.setState({
      isPincodeValid: validatePincodeField.isValid,
      pincode: validatePincodeField.value,
      pincodeErrorMsg: validatePincodeField.errorMsg,
    });
  }
  render() {
    const { pincode, pincodeErrorMsg } = this.state;
    return (
      <div className="nw-pincodechangeblock-wrapper nwc-translucentbackground-white">
        <form
          className="nw-pincodechangeblock-form"
          onSubmit={this.pinCodeSubmit}
        >
          <GridContainer>
            <GridRow>
              <GridColumn className="nw-pincodechangeblock-icon nwc-grid-col-sm-5">
                <span>
                  <i className="icomoon-marker3" />
                </span>
              </GridColumn>
              <GridColumn className="nw-pincodechangeblock-inputblock nwc-grid-col-sm-7">
                <div className="nw-pincodechangeblock-title">
                  {Checkout.CHECKOUT_MESSAGES.PINCODE_SCREEN_TITLE}
                </div>
                <Input
                  className="nw-pincodechangeblock-input"
                  name="pincode"
                  type="tel"
                  ref={values => {
                    this.pincodeInput = values;
                  }}
                  value={pincode}
                  maxLength={6}
                  minLength={6}
                  placeholder="pincode"
                  onChange={this.validatePincode}
                  validateWithPattern={[
                    {
                      pattern: /^[0-9]*$/,
                      msg:
                        "We need a valid 6-digit pincode. Try again, please.",
                    },
                  ]}
                />
                <div className="nw-pincodechangeblock-checkbtn">
                  <Button
                    type="submit"
                    className="nw-pincodechangeblock-btn nwc-btn-primary"
                    disabled={this.isPincodeValid}
                  >
                    CHECK
                  </Button>
                </div>
              </GridColumn>
            </GridRow>
          </GridContainer>
          <div className={`nw-pincodechangeblock-error ${this.isPinCodeError}`}>
            {pincodeErrorMsg}
          </div>
        </form>
      </div>
    );
  }
}
PincodeChangeBlock.wrappedComponent.defaultProps = {};
PincodeChangeBlock.wrappedComponent.propTypes = {
  onPincodeChange: PropTypes.func.isRequired,
  currentPincode: PropTypes.string.isRequired,
};

const getFinalComponent = component =>
  inject("AddressStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: PincodeChangeBlock.wrappedComponent,
  component: PincodeChangeBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CheckoutComponents/PincodeChangeBlock/index.js